import {ApolloClient} from 'apollo-client';
import {SchemaLink} from 'apollo-link-schema';
import {ApolloLink} from 'apollo-link';
import assign from 'object-assign';
import {
    makeExecutableSchema,
    addMockFunctionsToSchema
} from 'graphql-tools';
import fauxLatencyLink from './fauxLatencyLink';
import typeDefs from '../../../../api/schema.graphql';
import {Address, FileAsset, Date, DateTime, Decimal} from '@util/MockUtils';

const defaultMocks = {
    Query: () => ({}),
    Mutation: () => ({}),
    Date,
    DateTime,
    Decimal,
    Address,
    FileAsset
};

// todo -> determine better way to handle Singleton -> review "addMockFunctionsToSchema" of graphql-tools modules
class MockProvider {
    constructor () {
        if ( window.__UPI_MOCK_PROVIDER__ ) {
            return window.__UPI_MOCK_PROVIDER__;
        }

        console.warn( '[Initialize MockProvider]' );
        this.schema = makeExecutableSchema( {typeDefs} );
        this.schemaLink = new SchemaLink( {schema: this.schema} );
        this.mocks = defaultMocks;

        return window.__UPI_MOCK_PROVIDER__ = this;
    }

    extendMocks ( mocks ) {
        const {Mutation, Query, ...newMocks} = mocks;
        this.mocks = assign( {}, this.mocks, newMocks );

        let oldMutataion = this.mocks.Mutation();
        if ( Mutation ) {
            this.mocks.Mutation = () => ({
                ...oldMutataion,
                ...Mutation
            });
        }
        let oldQuery = this.mocks.Query();
        if ( Query ) {
            this.mocks.Query = () => ({
                ...oldQuery,
                ...Query
            });
        }
        // console.warn( '[Extended MockProvider]', this.mocks );
        addMockFunctionsToSchema( {
            schema: this.schema,
            // todo -> add DEEP extend to allow for extending Query and Mutation mocks
            mocks: this.mocks
        } );
    }

    createClient ( config ) {
        addMockFunctionsToSchema( {
            schema: this.schema,
            mocks: this.mocks
        } );

        return new ApolloClient( {
            ...config,
            link: ApolloLink.from( [config.link, fauxLatencyLink, this.schemaLink] )
        } );
    }
}

export default MockProvider;
